<template>
    <div>
        <side-menu />
        <loading-screen v-if="loadingScreen" />
        <section class="container profile-container">
            <div class="profile">
                <h1>Agendamentos</h1>
                <div class="card no-mobile">
                    <div class="card-header">

                    </div>
                    <div class="card-body">
                        <div class="card-table">
                            <table>
                                <thead>
                                    <tr class="t-row">
                                        <th>
                                            Data
                                        </th>
                                        <th>
                                            Nº Kit
                                        </th>
                                        <th>
                                            Cidade
                                        </th>
                                        <th>
                                            Endereço
                                        </th>
                                        <th>
                                            Horário
                                        </th>
                                        <th>
                                            Status
                                        </th>
                                        <th>

                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="!loadingScreen && schedules.length === 0">
                                        <td colspan="8" class="td">Não foram encontrados agendamentos</td>
                                    </tr>
                                    <tr v-for="schedule in schedules" v-bind:key="schedule.kit_id" >
                                        <td class="td">
                                            {{schedule.details.day}}
                                        </td>
                                        <td class="td">
                                            {{schedule.kit.number}}
                                        </td>
                                        <td class="td">
                                            {{schedule.city.name}}
                                        </td>
                                        <td class="td">
                                            {{schedule.address.address}} {{schedule.address.number}}
                                        </td>
                                        <td class="td">
                                            {{schedule.details.start_time}} às {{schedule.details.end_time}}
                                        </td>
                                        <td class="td">
                                            {{schedule.status}}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="card-footer">

                    </div>
                </div>
                <div class="cards">
                    <div class="card mobile" v-if="!loadingScreen && schedules.length === 0">
                        <div class="card-details">
                            <div class="detail">
                                Não foram encontrados agendamentos
                            </div>
                        </div>
                    </div>
                    <div class="card mobile" v-for="schedule in schedules" v-bind:key="schedule.kit_id">
                        <div class="card-details">
                            <div class="detail">
                                <h5>Data</h5>
                                <span>{{schedule.details.day}}</span>
                            </div>
                            <div class="detail">
                                <h5>Nº Kit</h5>
                                <span>{{schedule.kit.number}}</span>
                            </div>
                            <div class="detail">
                                <h5>Cidade</h5>
                                <span>{{schedule.city.name}}</span>
                            </div>
                            <div class="detail">
                                <h5>Endereço</h5>
                                <span>{{schedule.address.address}} {{schedule.address.number}}</span>
                            </div>
                            <div class="detail">
                                <h5>Horário</h5>
                                <span>{{schedule.details.start_time}} às {{schedule.details.end_time}}</span>
                            </div>
                            <div class="detail">
                                <h5>Status</h5>
                                <span>{{schedule.status}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import { LIST_SCHEDULES } from '../../services/schedule'

    export default {
        components: { },
        data() {
            return {
                loading: false,
                loadingScreen: false,
                schedules: {},
            }
        },
        methods: {
            async getSchedules() {
                this.loadingScreen = true;
                try{
                    const response = await LIST_SCHEDULES();
                    if(response) {
                        this.schedules = response;
                    }
                } catch(error) {

                } finally {
                    this.loadingScreen = false;
                }
            },
        },
        mounted() {
            this.getSchedules();
        }
    }
</script>

<style scoped>
  @import "./schedules.scss";
  @import "../Profile/responsive.css";
  @import "./responsive.css";
</style>



// WEBPACK FOOTER //
// src/views/Schedules/Schedules.vue